import React from 'react';
import { useHits } from '../../local-store';
import CollectionTermFacet from '../facets/collection-term';
import { FacetConfiguration } from '../../types';

interface Props {
  facetsConfiguration: Record<string, FacetConfiguration>;
}

/**
 * Collection-PLP facet strip: every configured facet rendered as a centred row of pills above the grid,
 * with no "Filters" heading, no sidebar and no Clear All — what the collection page looked like before it
 * moved onto the shared SSR grid.
 *
 * Note every facet TYPE renders as a term pill row here — the collection page has no range/colour/boolean
 * widgets — which matches the collection component's own facet mapping.
 */
const CollectionFacets: React.FC<Props> = ({ facetsConfiguration }) => {
  const { results } = useHits();

  return (
    <div className="flex flex-col items-start justify-center gap-12 md:items-center lg:gap-24 2xl:pb-10">
      {Object.keys(facetsConfiguration ?? {}).map((attribute) => {
        // A facet with no values for this result set would render an empty pill row, so hide it — same
        // rule the category panel applies.
        const isEmpty = !results?.disjunctiveFacets?.find((facet) => facet.name === attribute);
        return (
          <div key={attribute} className={isEmpty ? 'hidden' : 'block'}>
            <CollectionTermFacet
              attribute={attribute}
              label={facetsConfiguration[attribute]?.label}
            />
          </div>
        );
      })}
    </div>
  );
};

export default CollectionFacets;
